import Vue from "vue";

Vue.filter('photoSwipeItemImages', function (images, accessor) {

    if (!images) {
        return [];
    }

    const imageUrls = [];
    let imagesAccessor = 'all';

    if (images.variation && images.variation.length) {
        //imagesAccessor = 'variation';
    }

    //images = images.slice(0, 25);

    for (const image in images) {

        let imageUrl = images[image]['url'];
        let prevUrl  = images[image]['urlMiddle'];

        if (typeof imageUrl !== 'undefined') {
            imageUrls.push({
                src: imageUrl,
                position: images[image].position,
                w: 0,
                h: 0,
                msrc: prevUrl,
            });
        }
    }

    return imageUrls;
});
